<div fxFill fxLayoutAlign="space-between center">
  <h2 class="title">#{{ call.number }}</h2>
  <a [routerLink]="['/cliente']" class="back-to">
    <mat-icon>arrow_back_ios</mat-icon>
    Voltar
  </a>
</div>

<div fxLayout.lt-md="column" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" class="call-complete">
  <div fxFill>
    <app-call-main
      [user]="call.business_user"
      [description]="call.description"
      [userAgent]="call.call_user_agent"
      [createdAt]="call.added_at"
      [media]="call.media"
    ></app-call-main>

    <app-call-entry
      *ngFor="let item of call.items"
      [item]="item"
    ></app-call-entry>

    <app-call-new-entry
      [call]="call"
      origin="C"
      (newEntry)="newEntry($event)"
    ></app-call-new-entry>
  </div>
</div>
